// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.middleSectionGlobalCaruselContainer {
    margin: auto;
}

.middleSectionCarouselContainer {
    display: flex;
    position: relative;
    left: 0;
    justify-content: center;
    align-items: center;
    padding-top: 6em;
    padding-bottom: 6em;
}

.middleSectionGlobalCaruselContainerTitle {
    text-align: center;
}

.middleSectionCarousel {
    padding-top: 3em;
    min-height: auto;
    min-width: 15em;
    position: absolute;
    right: 0;
    left: 0;
    padding-bottom: 2em;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
}

.middleSectionCarouselText {
    padding-top: 1em;
    text-align: center;
}

.middleSectionGlobalCaruselContainerLine {
    border: none;
    height: 1px;
    background-color: var(--GrayBlue);
    /* Make the background transparent */
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.363);
    /* Subtle shadow */
}

.middleSectionGlobalCaruselContainerLine2 {
    border: none;
    height: 1px;
    background-color: var(--GrayBlue);
    box-shadow: 0px -4px 4px 1px rgba(0, 0, 0, 0.363);
    /* Shadow above */
}

.middleSectionCarouselRightContainer {
    padding-top: 0.5em;
    display: flex;

    justify-content: center;
    align-items: center;
    position: static;
    min-width: 20em;
    max-width: 20em;
}

.middleSectionCarouselLeftContainer {
    padding-top: 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    position: static;
    margin-right: auto;

    min-width: 20em;
    max-width: 20em;
    z-index: 2;
}

.middleSectionCarouselRightContainer2 {
    padding-top: 1.5em;
    padding-right: 4em;
}

.middleSectionCarouselsLeftContainer2 {
    padding-top: 1.5em;
    padding-left: 4em;
}

.middleSectionCarouselButtonPosition {
    display: flex;
    justify-content: flex-end;
}

.middleSectionCarouselImageLoaderImageDisplayNone {
    display: none;
}

.middleSectionCarouselImageLoaderImageDisplay {
    max-height: 15em;
    max-width: 20em;
    min-height: 15em;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0.6em;
    z-index: 5;
    box-shadow: -3px -3px 8px 2px rgba(0, 0, 0, 0.363);
    /* Standard syntax */
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.middleSectionCarouselImageLoaderImageDisplayLeft {
    max-height: 10em;
    max-width: 15em;
    min-height: 10em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0.6em;
    opacity: 0.4;
    box-shadow: -3px -3px 4px 2px rgba(0, 0, 0, 0.363);
    /* Standard syntax */
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.middleSectionCarouselImageLoaderImageDisplayRight {
    max-height: 10em;
    max-width: 15em;
    min-height: 10em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0.6em;
    opacity: 0.4;
    z-index: 1;
    box-shadow: -3px -3px 4px 2px rgba(0, 0, 0, 0.363);
    /* Standard syntax */
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.middleSectionCarouselImageLoaderImageDisplayRight2 {
    display: flex;
    max-height: 5em;
    max-width: 9em;
    min-height: 5em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0.6em;
    opacity: 0.2;
    z-index: 1;
    box-shadow: -3px -3px 2px 2px rgba(0, 0, 0, 0.363);
    /* Standard syntax */
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.middleSectionCarouselImageLoaderImageDisplayLeft2 {
    display: flex;
    max-height: 5em;
    max-width: 9em;
    min-height: 5em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0.6em;
    opacity: 0.2;
    z-index: 1;
    box-shadow: -3px -3px 2px 2px rgba(0, 0, 0, 0.363);
    /* Standard syntax */
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.middleSectionCarouselImageLoaderImageDisplayLeft2:hover {
    cursor: pointer;
    transition: transform 1s;
}

.middleSectionCarouselImageLoaderImageDisplayLeft:hover {
    cursor: pointer;
    transition: transform 1s;
}

.middleSectionCarouselImageLoaderImageDisplayRight:hover {
    cursor: pointer;
    transition: transform 1s;
}

.middleSectionCarouselImageLoaderImageDisplayRight2:hover {
    cursor: pointer;
    transition: transform 1s;

    z-index: 1;
}

.middleSectionCarouselImageLoaderImageDisplay:hover {
    cursor: pointer;
    transition: transform 1s;
    transform: scale(1.5);
}

.buttonMiddleSectionCarouselContainer {
    text-align: center;
}

.buttonMiddleSectionCarouselColor {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    border: 0px;
    background-color: var(--HighlightBlue);
}

.buttonMiddleSectionCarousel {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    border: 0px;
    background-color: var(--GrayBlue);
}

.buttonMiddleSectionCarousel:hover {
    background-color: var(--Gray);
    cursor: pointer;
}

.sideArrowLeftCarousel {
    display: block;
    max-width: 2em;
    transform: rotate(-90deg);
    filter: invert(48%) sepia(29%) saturate(476%) hue-rotate(136deg)
        brightness(118%) contrast(119%)
        drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.363));
    z-index: 20;
    margin-left: 0;
    cursor: pointer;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    opacity: 0.6;
}

.sideArrowRightCarousel {
    max-width: 2em;
    transform: rotate(90deg);
    filter: invert(48%) sepia(29%) saturate(476%) hue-rotate(136deg)
        brightness(118%) contrast(119%)
        drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.363));
    margin-right: 0;
    cursor: pointer;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    z-index: 20;
    opacity: 0.6;
}

.sideArrowRightCarousel:hover {
    opacity: 1;
}

.sideArrowLeftCarousel:hover {
    opacity: 1;
}

@media screen and (max-width: 1318px) {
    .middleSectionCarouselImageLoaderImageDisplay {
        max-height: 10em;
        max-width: 15em;
        min-height: 10em;
    }

    .middleSectionCarouselImageLoaderImageDisplayLeft {
        max-height: 6em;
        max-width: 11em;
        min-height: 6em;
    }

    .middleSectionCarouselImageLoaderImageDisplayRight {
        max-height: 6em;
        max-width: 11em;
        min-height: 6em;
    }

    .middleSectionCarouselImageLoaderImageDisplayRight2 {
        max-height: 3em;
        max-width: 7em;
        min-height: 3em;
    }

    .middleSectionCarouselImageLoaderImageDisplayLeft2 {
        max-height: 3em;
        max-width: 7em;
        min-height: 3em;
    }
}

@media only screen and (max-width: 768px) {
    .middleSectionCarouselImageLoaderImageDisplay {
        max-height: 8em;
        max-width: 15em;
        min-height: 8em;
    }

    .middleSectionCarouselImageLoaderImageDisplayLeft {
        max-height: 4em;
        max-width: 10em;
        min-height: 4em;
    }

    .middleSectionCarouselImageLoaderImageDisplayRight {
        max-height: 4em;
        max-width: 10em;
        min-height: 4em;
    }

    .middleSectionCarouselRightContainer2 {
        display: none;
    }

    .middleSectionCarouselsLeftContainer2 {
        display: none;
    }

    .middleSectionCarouselRightContainer {
        min-width: 2em;
        padding-right: none;
    }

    .middleSectionCarouselLeftContainer {
        min-width: 2em;
    }
}

@media screen and (max-width: 320px) {
    .middleSectionCarouselRightContainer2 {
        display: none;
    }

    .middleSectionCarouselsLeftContainer2 {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Carousel/carousel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,oCAAoC;IACpC,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,iDAAiD;IACjD,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;;IAElB,eAAe;IACf,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,kDAAkD;IAClD,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,kDAAkD;IAClD,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,kDAAkD;IAClD,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,kDAAkD;IAClD,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,kDAAkD;IAClD,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;;IAExB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB;;qDAEiD;IACjD,WAAW;IACX,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB;;qDAEiD;IACjD,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".middleSectionGlobalCaruselContainer {\n    margin: auto;\n}\n\n.middleSectionCarouselContainer {\n    display: flex;\n    position: relative;\n    left: 0;\n    justify-content: center;\n    align-items: center;\n    padding-top: 6em;\n    padding-bottom: 6em;\n}\n\n.middleSectionGlobalCaruselContainerTitle {\n    text-align: center;\n}\n\n.middleSectionCarousel {\n    padding-top: 3em;\n    min-height: auto;\n    min-width: 15em;\n    position: absolute;\n    right: 0;\n    left: 0;\n    padding-bottom: 2em;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.middleSectionCarouselText {\n    padding-top: 1em;\n    text-align: center;\n}\n\n.middleSectionGlobalCaruselContainerLine {\n    border: none;\n    height: 1px;\n    background-color: var(--GrayBlue);\n    /* Make the background transparent */\n    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.363);\n    /* Subtle shadow */\n}\n\n.middleSectionGlobalCaruselContainerLine2 {\n    border: none;\n    height: 1px;\n    background-color: var(--GrayBlue);\n    box-shadow: 0px -4px 4px 1px rgba(0, 0, 0, 0.363);\n    /* Shadow above */\n}\n\n.middleSectionCarouselRightContainer {\n    padding-top: 0.5em;\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n    position: static;\n    min-width: 20em;\n    max-width: 20em;\n}\n\n.middleSectionCarouselLeftContainer {\n    padding-top: 0.5em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: static;\n    margin-right: auto;\n\n    min-width: 20em;\n    max-width: 20em;\n    z-index: 2;\n}\n\n.middleSectionCarouselRightContainer2 {\n    padding-top: 1.5em;\n    padding-right: 4em;\n}\n\n.middleSectionCarouselsLeftContainer2 {\n    padding-top: 1.5em;\n    padding-left: 4em;\n}\n\n.middleSectionCarouselButtonPosition {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayNone {\n    display: none;\n}\n\n.middleSectionCarouselImageLoaderImageDisplay {\n    max-height: 15em;\n    max-width: 20em;\n    min-height: 15em;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0.6em;\n    z-index: 5;\n    box-shadow: -3px -3px 8px 2px rgba(0, 0, 0, 0.363);\n    /* Standard syntax */\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayLeft {\n    max-height: 10em;\n    max-width: 15em;\n    min-height: 10em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0.6em;\n    opacity: 0.4;\n    box-shadow: -3px -3px 4px 2px rgba(0, 0, 0, 0.363);\n    /* Standard syntax */\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayRight {\n    max-height: 10em;\n    max-width: 15em;\n    min-height: 10em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0.6em;\n    opacity: 0.4;\n    z-index: 1;\n    box-shadow: -3px -3px 4px 2px rgba(0, 0, 0, 0.363);\n    /* Standard syntax */\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayRight2 {\n    display: flex;\n    max-height: 5em;\n    max-width: 9em;\n    min-height: 5em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0.6em;\n    opacity: 0.2;\n    z-index: 1;\n    box-shadow: -3px -3px 2px 2px rgba(0, 0, 0, 0.363);\n    /* Standard syntax */\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayLeft2 {\n    display: flex;\n    max-height: 5em;\n    max-width: 9em;\n    min-height: 5em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0.6em;\n    opacity: 0.2;\n    z-index: 1;\n    box-shadow: -3px -3px 2px 2px rgba(0, 0, 0, 0.363);\n    /* Standard syntax */\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayLeft2:hover {\n    cursor: pointer;\n    transition: transform 1s;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayLeft:hover {\n    cursor: pointer;\n    transition: transform 1s;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayRight:hover {\n    cursor: pointer;\n    transition: transform 1s;\n}\n\n.middleSectionCarouselImageLoaderImageDisplayRight2:hover {\n    cursor: pointer;\n    transition: transform 1s;\n\n    z-index: 1;\n}\n\n.middleSectionCarouselImageLoaderImageDisplay:hover {\n    cursor: pointer;\n    transition: transform 1s;\n    transform: scale(1.5);\n}\n\n.buttonMiddleSectionCarouselContainer {\n    text-align: center;\n}\n\n.buttonMiddleSectionCarouselColor {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    border: 0px;\n    background-color: var(--HighlightBlue);\n}\n\n.buttonMiddleSectionCarousel {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    border: 0px;\n    background-color: var(--GrayBlue);\n}\n\n.buttonMiddleSectionCarousel:hover {\n    background-color: var(--Gray);\n    cursor: pointer;\n}\n\n.sideArrowLeftCarousel {\n    display: block;\n    max-width: 2em;\n    transform: rotate(-90deg);\n    filter: invert(48%) sepia(29%) saturate(476%) hue-rotate(136deg)\n        brightness(118%) contrast(119%)\n        drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.363));\n    z-index: 20;\n    margin-left: 0;\n    cursor: pointer;\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    opacity: 0.6;\n}\n\n.sideArrowRightCarousel {\n    max-width: 2em;\n    transform: rotate(90deg);\n    filter: invert(48%) sepia(29%) saturate(476%) hue-rotate(136deg)\n        brightness(118%) contrast(119%)\n        drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.363));\n    margin-right: 0;\n    cursor: pointer;\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    z-index: 20;\n    opacity: 0.6;\n}\n\n.sideArrowRightCarousel:hover {\n    opacity: 1;\n}\n\n.sideArrowLeftCarousel:hover {\n    opacity: 1;\n}\n\n@media screen and (max-width: 1318px) {\n    .middleSectionCarouselImageLoaderImageDisplay {\n        max-height: 10em;\n        max-width: 15em;\n        min-height: 10em;\n    }\n\n    .middleSectionCarouselImageLoaderImageDisplayLeft {\n        max-height: 6em;\n        max-width: 11em;\n        min-height: 6em;\n    }\n\n    .middleSectionCarouselImageLoaderImageDisplayRight {\n        max-height: 6em;\n        max-width: 11em;\n        min-height: 6em;\n    }\n\n    .middleSectionCarouselImageLoaderImageDisplayRight2 {\n        max-height: 3em;\n        max-width: 7em;\n        min-height: 3em;\n    }\n\n    .middleSectionCarouselImageLoaderImageDisplayLeft2 {\n        max-height: 3em;\n        max-width: 7em;\n        min-height: 3em;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .middleSectionCarouselImageLoaderImageDisplay {\n        max-height: 8em;\n        max-width: 15em;\n        min-height: 8em;\n    }\n\n    .middleSectionCarouselImageLoaderImageDisplayLeft {\n        max-height: 4em;\n        max-width: 10em;\n        min-height: 4em;\n    }\n\n    .middleSectionCarouselImageLoaderImageDisplayRight {\n        max-height: 4em;\n        max-width: 10em;\n        min-height: 4em;\n    }\n\n    .middleSectionCarouselRightContainer2 {\n        display: none;\n    }\n\n    .middleSectionCarouselsLeftContainer2 {\n        display: none;\n    }\n\n    .middleSectionCarouselRightContainer {\n        min-width: 2em;\n        padding-right: none;\n    }\n\n    .middleSectionCarouselLeftContainer {\n        min-width: 2em;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .middleSectionCarouselRightContainer2 {\n        display: none;\n    }\n\n    .middleSectionCarouselsLeftContainer2 {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
